// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiEditInferencer } from "@refinedev/inferencer/mui";

// export const PurshaseEdit: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiEditInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };

import {
  Box,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useEffect } from "react";
import { Controller } from "react-hook-form";
import { useQuery } from "react-query";
import { getContainers } from "services/container";

export const PurshaseEdit = () => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    register,
    formState: { errors },
    watch,
    setValue,
    control,
  } = useForm();

  const { quantity, prix, avance } = watch();
  const totalPrice = quantity && prix ? quantity * prix : 0;
  const totalReste = avance && totalPrice ? totalPrice - avance : 0;

  useEffect(() => {
    setValue("total", totalPrice);
    setValue("reste", totalReste);
  }, [totalPrice, totalReste]);

  const { data: user } = useGetIdentity<{
    name: string;
    avatar: any;
    id: any;
  }>();
  const userId = user && user.id;

  const { data: dataContainers } = useQuery({
    queryKey: "containers",
    queryFn: getContainers(false),
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <FormControl sx={{ mt: -1, display: "none" }}>
          <TextField
            type="hidden"
            {...register("user", {
              required: translate('this-field-is-required'),
            })}
            error={!!(errors as any)?.user}
            helperText={(errors as any)?.user?.message}
            margin="normal"
            value={userId}
            InputLabelProps={{ shrink: true }}
            name="user"
          />
        </FormControl>
        <TextField
          {...register("quantity", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.quantity}
          helperText={(errors as any)?.quantity?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Quantity"
          name="quantity"
        />
        <TextField
          {...register("source", {
            required: translate('this-field-is-required'),
          })}
          error={!!(errors as any)?.source}
          helperText={(errors as any)?.source?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Source"
          name="source"
        />
        <TextField
          {...register("prix", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.prix}
          helperText={(errors as any)?.prix?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Prix"
          name="prix"
        />
        <TextField
          {...register("total", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.total}
          helperText={(errors as any)?.total?.message}
          margin="normal"
          fullWidth
          disabled
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Total"
          name="total"
        />
        <TextField
          {...register("avance", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.avance}
          helperText={(errors as any)?.avance?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Avance"
          name="avance"
        />
        <TextField
          {...register("reste", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.reste}
          helperText={(errors as any)?.reste?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Reste"
          name="reste"
          disabled
        />
        <Controller
          control={control}
          name="container"
          rules={{ required: translate('this-field-is-required') }}
          defaultValue={null as any}
          render={({ field }) => (
            <FormControl sx={{ mb: 1 }}>
              <FormLabel>Container</FormLabel>
              <Select {...field} name="container" label="Container">
                <MenuItem>Select Container</MenuItem>
                {(dataContainers || []).map((item: any, index: number) => (
                  <MenuItem key={index} value={item.id}>
                    [{item?.type}] {item?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </Box>
    </Edit>
  );
};
